export default "__VITE_ASSET__C1hzvQO9__"